/* eslint-disable no-constant-condition */
/* eslint-disable max-len */
/* eslint-disable no-undef */
import React from "react";
import { ToastContainer } from "react-toastify";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import MasterService from "../../../../../services/MasterService";
import UserService from "../../../../../services/UserService";
import ToastService from "../../../../../services/ToastService";
import moment from "moment";
import noimageSvg from "../../../../../public/noimage.svg";
import uploadicoSvg from "../../../../../public/uploadfileico.svg";
import drequipSvg from "../../../../../public/stethoscope.svg";
import adduserSvg from "../../../../../public/adduserico.svg";
import nofileSvg from "../../../../../public/nofile.svg";
import { showLoading } from "react-global-loading";
class CreateUser extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      password: '', confirmPassword: '', pwdValidation: [], setConfirmTouched: false, setPwdTouched: false,
      user: this.props.users[this.props.selectedUser],
      selectedCountry: 0,
      userData: this.props.userData,
      type: this.props.type,
      centerStatus: [
        { name: "Mon", status: true },
        { name: "Tue", status: true },
        { name: "Wed", status: true },
        { name: "Thur", status: true },
        { name: "Fri", status: true },
        { name: "Sat", status: true },
      ],
      imageApi: "",
      address: "",
      username: "",
      contact: "",
      userDesig: "",
      pincode: "",
      selectedCity: "",
      selectedState: "",
      email: "",
      countries: [],
    };
  }

  componentDidMount = () => {
    this.state.type === "view"
      ? this.getUserDetail(this.state.userData?.ID)
      : "";
    this.getAllCountries();
  };

  isValidpassword = (value, name) => {
    const { pwdValidation } = this.state;
    this.setState({ touchedPwd: name });
    const pwdPattern = new RegExp(/(?=.*?[A-Za-z])(?=.*?[0-9])(?=.*?[@$!%*#?~(&)+=^_-]).{8,}/);

    if (!pwdPattern.test(value) || (value.length < 8)) {
      pwdValidation[name] = <div className="isaerror" role="alert">Password must be at least 8 characters long, include letters, numbers, & 1 special character.</div>;

    } else pwdValidation[name] = '';
    // } else { this.error = false; }

  };

  getUserDetail = id => {
    UserService.getUsersDetail(id)
      .then(result => {
        if (!result) {
          return;
        }
        this.setState({
          userData: result.data,
          address: result.data.user_address,
          username: result.data.display_name,
          contact: result.data.user_phone,
          userDesig: result.data.designation,
          pincode: result.data.pincode,
          selectedCity: result.data.user_city,
          selectedState: result.data.user_state,
          email: result.data.user_email,
          imageApi: result.data.user_image,
          selectedCountry: result.data.user_country.id,
        });
      })
      .catch(err => {
        console.error(err);
      });
  };

  getAllCountries = () => {
    MasterService.getAyushCountries()
      .then(result => {
        if (!result) {
          return;
        }
        this.setState({ countries: result });
      })
      .catch(err => {
        console.error(err);
      });
  };

  onUserCreation = () => {
    const {
      type,
      selectedCountry,
      address,
      username,
      contact,
      userDesig,
      pincode,
      selectedCity,
      selectedState,
      email,
      imageApi,
      user, password
    } = this.state;
    if (selectedCountry && username && email && (type === 'create' ? password : true)) {
      var emailregex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
      var mobPattern = new RegExp(
        /^([+]?[\s0-9]+)?(\d{3}|[(]?[0-9]+[)])?([-]?[\s]?[0-9])+$/i,
      );

      if (contact) {
        if (!mobPattern.test(contact) || contact.length !== 10)
          return ToastService.error("Please enter valid mobile");
      }
      if (pincode) {
        if (pincode.length !== 6)
          return ToastService.error("Please enter valid pincode");
      }
      if (email) {
        if (!emailregex.test(email))
          return ToastService.error("Please enter valid email");
      }

      showLoading(true);
      var data = new FormData();
      data.append("user_login", username);
      data.append("user_email", email);
      data.append("role", user.name);
      data.append("designation", userDesig);
      data.append("user_address", address);
      type === 'create' ? '' : data.append("password", password);
      data.append("user_country", selectedCountry);
      data.append("user_state", selectedState);
      data.append("user_city", selectedCity);
      data.append("user_phone", contact);
      data.append("pincode", pincode);
      data.append("blog_id", selectedCountry);
      data.append("user_image", imageApi);
      if (this.state.userData?.ID) {
        data.append('userid', this.state.userData?.ID);
        UserService.updateUser(data).then(result => {
          showLoading(false);
          result.data.status === 200
            ? (ToastService.success(result.data.message),
              this.props.dismissModal())
            : (ToastService.error(result.data.message),
              this.props.dismissModal());
        });
      } else {
        console.log([...data.entries()]);
        UserService.createUser(data).then(result => {
          showLoading(false);
          result.data.status === 200
            ? (ToastService.success(result.data.message),
              this.props.dismissModal())
            : (ToastService.error(result.data.message),
              this.props.dismissModal());
        });
      }
    } else {
      return ToastService.error("Please fill required details");
    }
  };

  onImageSelection = event => {
    this.setState({
      imageApi: event.target.files[0],
    });
  };

  deleteImage = () => {
    this.setState({ imageApi: "" });
  };

  samePwdCheck = (password, confirmPwd) => {
    if (password === confirmPwd) this.setState({ pwdConfirm: " " });
    else this.setState({ pwdConfirm: <div className="isaerror" role="alert">Confirm password is not matched</div> });
  };

  toggleStatus = (status, index) => {
    var arr = this.state.centerStatus;
    arr.splice(index, 1, {
      name: this.state.centerStatus[index].name,
      status: !status,
    });
    this.setState({ centerStatus: arr });
  };

  render() {
    const {
      countries,
      selectedCountry,
      address,
      username,
      contact,
      userDesig,
      pincode,
      selectedCity,
      selectedState,
      email,
      user,
      imageApi,
      centerStatus,
      type,
      userData, confirmPassword, password, pwdValidation, pwdConfirm, touchedPwd
    } = this.state;
    return (
      <>
        <ToastContainer />
        <div className="modal-content bg-white p-3">
          <div className="modal-header">
            <h1 className="modal-title fs-5 w-100">
              {user.name} - {type === "view" ? "View" : "Create"}{" "}
            </h1>
            <button
              className="btn-close"
              aria-label="Close"
              onClick={() => this.props.dismissModal()}
            ></button>
          </div>
          <div className="modal-body">
            <div className="row mt-3">
              <div className="col-md-6 flcc">
                <p> Image:</p>
                <div className="upload-drag flg d-flex align-items-center justify-content-center">
                  <div className="uploadbox">
                    {imageApi ? (
                      <>
                        <img
                          src={
                            typeof imageApi === "object"
                              ? URL.createObjectURL(imageApi)
                              : imageApi
                          }
                        />{" "}
                      </>
                    ) : (
                      <>
                        {" "}
                        <img
                          src={nofileSvg}
                          className="d-block noimg"
                          alt="upload"
                        />
                        <span className="d-block">
                          Upload Image by clicking to upload
                        </span>
                        <label
                          htmlFor="productname"
                          id="uploadimagg"
                          className="bldlbl"
                        >
                          Image of the {user.name}{" "}
                        </label>
                        <input
                          disabled={type === "view"}
                          aria-labelledby="uploadimagg"
                          className="upload-btn"
                          type="file"
                          accept=".png, .jpg, .jpeg"
                          name="file"
                          onChange={this.onImageSelection}
                        />
                      </>
                    )}
                  </div>
                  {imageApi && type !== "view" && (
                    <div className="d-block del-btn">
                      <button onClick={() => this.deleteImage()}>
                        <i className="fa fa-trash" aria-hidden="true"></i>
                      </button>
                    </div>
                  )}
                </div>
              </div>
              <div className="col-md-6 mt-4">
                <div className="form-group mb-3 position-relative">
                  <label htmlFor="username" className="bldlbl" id="username">
                    Name*
                  </label>
                  <input
                    disabled={type === "view"}
                    type="text"
                    aria-labelledby="username"
                    value={username}
                    onChange={e => this.setState({ username: e.target.value })}
                    className="form-control inppd"
                    placeholder="Enter name here"
                    name="username"
                  />
                </div>
                <div className="form-group mb-4 position-relative">
                  <label
                    htmlFor="contactnumber"
                    className="bldlbl"
                    id="usercontactno"
                  >
                    Contact number
                  </label>
                  <input
                    disabled={type === "view"}
                    type="number"
                    aria-labelledby="usercontactno"
                    value={contact}
                    onChange={e => this.setState({ contact: e.target.value })}
                    className="form-control inppd"
                    name="contactnumber"
                    placeholder="Enter Center’s contact number"
                  />
                </div>
                <div className="form-group mb-4 position-relative">
                  <label htmlFor="mailid" className="bldlbl" id="useremail">
                    E-mail/Login Id
                  </label>
                  <input
                    disabled={type === "view"}
                    type="email"
                    aria-labelledby="useremail"
                    value={email}
                    onChange={e => this.setState({ email: e.target.value })}
                    className="form-control inppd"
                    name="mailid"
                    placeholder="Enter Email Id"
                  />
                  <h7>*this is used for logging in</h7>
                </div>

                {/* <div className="form-group mb-3 position-relative">
                  <label htmlFor="Userdepartment" className="form-label over-label"> Department</label>
                  <input disabled={type === 'view'} type="text" value={userDept} onChange={(e) => this.setState({ userDept: e.target.value })} className="form-control inppd" placeholder="Enter the  department here" name="Userdepartment" />
                </div> */}
                {/* <div className="form-group mb-3 position-relative">
                  <label htmlFor="designation" className="bldlbl" id="userdesig">User's Designation</label>
                  <input disabled={type === 'view'} type="text" value={userDesig} aria-labelledby="userdesig" onChange={(e) => this.setState({ userDesig: e.target.value })} className="form-control inppd" placeholder="Enter the  designation here" name="designation" />
                </div> */}

                {/* <div className="form-group position-relative">
                  <label htmlFor="eventname" className="form-label">Domains*:</label>
                  <div className="btn-group d-block event-check chlst" role="group" aria-label="Basic checkbox toggle button group">
                    <span>
                      <input disabled={type === 'view'} type="checkbox" className="btn-check" autoComplete="off" />
                      <label className="btn btn-outline-dark inpbr_mc" >Ayurveda</label>
                    </span>
                    <span>
                      <input disabled={type === 'view'} type="checkbox" className="btn-check" autoComplete="off" />
                      <label className="btn btn-outline-dark inpbr_mc" >Yoga</label>
                    </span>
                    <span>
                      <input disabled={type === 'view'} type="checkbox" className="btn-check" autoComplete="off" />
                      <label className="btn btn-outline-dark inpbr_mc" >Unani</label>
                    </span>
                    <span>
                      <input disabled={type === 'view'} type="checkbox" className="btn-check" autoComplete="off" />
                      <label className="btn btn-outline-dark inpbr_mc" >Sowa-Rigpa</label>
                    </span>
                    <span>
                      <input disabled={type === 'view'} type="checkbox" className="btn-check" autoComplete="off" />
                      <label className="btn btn-outline-dark inpbr_mc" >Homeopathy</label>
                    </span>
                    <span>
                      <input disabled={type === 'view'} type="checkbox" className="btn-check" autoComplete="off" />
                      <label className="btn btn-outline-dark inpbr_mc" >Naturopathy</label>
                    </span>
                  </div>
                </div> */}

                {/* <div className="row mt-4">
                  <div className="col-md-6">
                    <div className="form-group mb-4 position-relative">
                      <label htmlFor="eventname" className="form-label over-label">Supervising country *</label>
                      <select name='orderby' className='form-control' aria-label='Shop order' value={selectedCountry}
                        onChange={(e) => this.setState({ selectedCountry: e.target.value })}>
                        <option defaultValue='selected'>Countries</option>
                        {countries.map((item, index) => <option key={index} value={item.id}>{item.blogname}</option>)}
                      </select>
                    </div >
                  </div >

                </div> */}
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-md-6">
                <div className="form-group mb-3 position-relative">
                  <label
                    htmlFor="countryname"
                    id="usercountry"
                    className="bldlbl"
                  >
                    Country*
                  </label>
                  <select
                    name="orderby"
                    className="form-control inppd"
                    aria-labelledby="usercountry"
                    aria-label="Shop order"
                    value={selectedCountry}
                    disabled={type === "view"}
                    onChange={e =>
                      this.setState({ selectedCountry: e.target.value })
                    }
                  >
                    <option defaultValue="selected">Countries*</option>
                    {countries.map((item, index) => (
                      <option key={index} value={item.id}>
                        {item.blogname}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="form-group mb-3 position-relative">
                  <label htmlFor="statename" className="bldlbl" id="userstate">
                    State
                  </label>
                  <input
                    disabled={type === "view"}
                    type="text"
                    value={selectedState}
                    aria-labelledby="userstate"
                    onChange={e =>
                      this.setState({ selectedState: e.target.value })
                    }
                    className="form-control inppd"
                    name="state"
                    placeholder="Enter your State"
                  />
                </div>

                <div className="form-group mb-4 position-relative">
                  <label htmlFor="cityname" className="bldlbl" id="usercity">
                    City
                  </label>
                  <input
                    disabled={type === "view"}
                    type="text"
                    value={selectedCity}
                    aria-labelledby="usercity"
                    onChange={e =>
                      this.setState({ selectedCity: e.target.value })
                    }
                    className="form-control inppd"
                    name="city"
                    placeholder="Enter your City"
                  />
                </div>
                <div className="form-group mb-4 position-relative">
                  <label htmlFor="pincode" className="bldlbl" id="pincode">
                    Pin/ZIP Code
                  </label>
                  <input
                    disabled={type === "view"}
                    type="number"
                    value={pincode}
                    aria-labelledby="pincode"
                    onChange={e => this.setState({ pincode: e.target.value })}
                    className="form-control inppd"
                    name="pincode"
                    placeholder="Enter your pin code"
                  />
                </div>
              </div>
              <div className="col-md-6">
                {
                  ['view', 'edit'].includes(type) ? '' : <>
                    <div className="form-group mb-4 position-relative">
                      <label htmlFor="clinicname" className="bldlbl" id="myfee">Password*</label>
                      <input
                        type="password"
                        className="form-control"
                        name="password"
                        minLength="8"
                        disabled={['view', 'edit'].includes(type)}
                        value={password}
                        onChange={(e) => (this.setState({ password: e.target.value }))}
                        onBlur={(e) => (this.setState({ setPwdTouched: true }), this.isValidpassword(e.target.value, e.target.name))}
                      />
                      {touchedPwd === 'password' && pwdValidation.password}
                    </div>
                    <div className="form-group mb-4 position-relative">
                      <label htmlFor="clinicname" className="bldlbl" id="myfee">Confirm Password*</label>
                      <input
                        type="password"
                        className="form-control"
                        name="confirmPassword"
                        minLength="8"
                        disabled={pwdValidation.password || ['view', 'edit'].includes(type)}
                        value={confirmPassword}
                        onChange={(e) => this.setState({ confirmPassword: e.target.value })}
                        onBlur={(e) => (this.setState({ setConfirmTouched: true }), this.samePwdCheck(password, e.target.value), this.isValidpassword(e.target.value, e.target.name))}
                      />
                      {touchedPwd === 'confirmPassword' && (pwdValidation.confirmPassword || pwdConfirm)}
                    </div>
                  </>}
                <div className="form-group mb-4 position-relative">
                  <label htmlFor="useraddress" className="bldlbl" id="useraddr">
                    Address
                  </label>
                  <textarea
                    disabled={type === "view"}
                    value={address}
                    aria-labelledby="useraddr"
                    onChange={e => this.setState({ address: e.target.value })}
                    className="form-control textarea-height inppd"
                    name="useraddress"
                    rows="3"
                    placeholder="Enter this center’s address"
                  />
                </div>

              </div>
            </div>
          </div>
          <div className="modal-footer">
            {/* <button type="button" className="btn theme-btn-outline">Temporarily Suspend Account</button>
        <button type="button" className="btn theme-btn-outline mx-4">Delete User</button> */}
            {type === 'view' ? <button type="button" onClick={() => this.setState({ type: 'edit' })} className="btn theme-btn-fill">Edit</button> : <button type="button" onClick={() => this.onUserCreation()} className="btn theme-btn-fill">Save</button>}
          </div>
        </div>
      </>
    );
  }
}
export default CreateUser;
